import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[zeroForbiddenNames]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ForbiddenNamesDirective, multi: true }],
  standalone: true,
})
export class ForbiddenNamesDirective implements Validator {
  @Input('zeroForbiddenNames') public forbiddenNames: string[] = [];

  public validate(c: AbstractControl): { [key: string]: boolean } | null {
    const _forbiddenNames = this.forbiddenNames?.map((name) => name.trim().toLowerCase()) ?? [];
    if (_forbiddenNames.length > 0 && _forbiddenNames.includes(c.value?.trim()?.toLowerCase())) {
      return { forbiddenName: true };
    }
    return null;
  }
}
